import { render, staticRenderFns } from "./MensagemConfirmacao.vue?vue&type=template&id=0c7581d8&scoped=true&"
import script from "./MensagemConfirmacao.vue?vue&type=script&lang=js&"
export * from "./MensagemConfirmacao.vue?vue&type=script&lang=js&"
import style0 from "./MensagemConfirmacao.vue?vue&type=style&index=0&id=0c7581d8&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7581d8",
  null
  
)

export default component.exports